/* eslint-disable react/require-default-props */
import React from 'react';
import {
  Box, IconButton, InputAdornment,
} from '@mui/material';
import { SearchIcon } from '../../../assets/icons';
import { CustomInputField } from '../custom-text-field';

interface SearchBarProps {
  onBlur?: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  value?: string;
  name?: string;
  placeholder?: string;
}
const SearchBar = React.forwardRef(
  ({
    onChange, onBlur, value, name, placeholder,
  }: SearchBarProps, ref) => (
    <Box>
      <CustomInputField
        onChange={onChange ?? undefined}
        startAdornment={(
          <InputAdornment position="start">
            <IconButton>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        )}
        type="text"
        onBlur={onBlur ?? undefined}
        value={value ?? undefined}
        name={name ?? undefined}
        ref={ref ?? undefined}
        placeholder={placeholder ?? undefined}
        fullWidth
      />
    </Box>
  ),
);
export default SearchBar;
